export const defaultInvoicingDocumentTemplate = (baseDate: Date = new Date()) => `{
  "documentType": "INVOICE",
  "invoiceDate": "${baseDate.toISOString()}",
  "dueDate": "${new Date(baseDate.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString()}",
  "invoicingParty": {
    "commercialName": "My Vendor Company"
  },
  "invoicedParty": {
    "commercialName": "ACME SARL"
  },
  "invoiceLines": [
    {
      "invoiceLineId": "INV-LINE-001",
      "amount": {
        "value": 1200,
        "unit": "EUR"
      },
      "unitPrice": {
        "value": 120,
        "unit": "EUR"
      }
    }
  ],
  "invoiceTaxes": [
    {
      "taxType": "VAT",
      "amount": {
        "value": 240,
        "unit": "EUR"
      }
    }
  ],
  "totalAmount": {
    "value": 1200,
    "unit": "EUR"
  },
  "totalAmountIncludingTaxes": {
    "value": 1440,
    "unit": "EUR"
  },
  "externalReferences": [
    {
      "externalReferenceType": "PROVIDER_ID",
      "reference": "INV-2026-001"
    }
  ]
}`;
